import * as React from 'react';
import { useContext } from 'react';

type GroupedComponentsWrapperContextType = {
  size: number;
};

const GroupedComponentsWrapperContext = React.createContext<GroupedComponentsWrapperContextType | undefined>(undefined);

/**
 * @description Hook to access a grouped context metadata
 */
export const useGroupedComponentsWrapperContext = () => {
  const context = useContext(GroupedComponentsWrapperContext);

  return context;
};

export default GroupedComponentsWrapperContext;
